import { useState } from 'react'
import Select from 'react-select';
import Button from '../../general/Button';
import Translation from '../../Translation/cont/Translation';

const AddNewAttributeColorSelect = ({
    filteredTechnicals,
    attributeColorSettings,
    addItem
}) => {
    if(!filteredTechnicals) {
        return ''
    } else {
        const [currentValue, setCurrentvalue] = useState('')
        const [technicalActive, setActiveTechnical] = useState('')
        const options = []
        let selectRef = ''
        const selectSettings = {
            menuShouldBlockScroll:true,
            isClearable:true,
            className:'select-container',
            isSearchable:false,
            classNamePrefix:"select"
        }

        const sortedAttributes = Object.keys(filteredTechnicals).sort(function(a, b) {
            const attrA = filteredTechnicals[a].name.toLowerCase()
            const attrB = filteredTechnicals[b].name.toLowerCase()
            
            return attrB > attrA ? -1 : attrB < attrA ? 1 : 0
        })

        const onChange = (option)  => {
            setCurrentvalue(option)
            setActiveTechnical(filteredTechnicals[option.value])
        }

        sortedAttributes.map((technicalId) => {
            const value = technicalId
            const label = filteredTechnicals[technicalId].name
            options.push({value,label})
        })

        return (
            <div className="gap-50 add-technical">
                <Translation id={'signage_filter_technical'} after={' '}>Filmreihe</Translation>
                <Translation id={'add_button'}>hinzufügen</Translation>
                <div className='add-technical-select-wrapper'>
                    <Select {...selectSettings}
                        options={options}
                        ref={ref => { selectRef = ref; }}
                        placeholder={<Translation id={'signage_filter_select_option_title'}></Translation>}
                        value={currentValue} 
                        onChange={(option) => onChange(option)}
                    />
                    <Button
                        className="button button-submit" 
                        transId={'add_button'}
                        onClick={() => {
                            if(technicalActive) {
                                addItem(technicalActive, attributeColorSettings)
                                setCurrentvalue('')
                                setActiveTechnical('')
                            }
                        }}
                        hideText={false}
                    />  
                </div>
            </div>
        )
    }
}

export default AddNewAttributeColorSelect